module.exports = __webpack_public_path__ + "img/delete-button.0b355323.svg";